module.exports = __webpack_public_path__ + "slide10.1c866ceb2e4d2bc673df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide10.jpg
// module id = ./src/assets/images/private/home/slide10.jpg
// module chunks = main